import DetailWebView from './webview';
import GameWebView from './game-webview';
export default DetailWebView;
export {GameWebView};
